import React from "react";
import COLORS from "../../constants/colors";
import FlowTopBar from "../common/FlowTopBar";
import MaskedInputPlaceholder from "../common/MaskedInputPlaceholder";
import {
  heroWordStyle,
  mainCardStyle,
  pageStyle,
  primaryBtnStyle,
  centerSubStyle,
} from "../../styles/commonStyles";
import { speakFrench } from "../../utils/speech";

// 新增：动画样式
const animationStyles = `
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  .review-input-container {
    animation: fadeInUp 0.5s ease-out;
  }
  
  .review-input-focus:focus {
    border-color: #667eea !important;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15) !important;
  }
  
  .review-submit-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .review-submit-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
  }
  
  .review-submit-btn:active {
    transform: translateY(0);
  }
`;

export default function ReviewPhaseTwoInput({
  word,
  progressText,
  inputValue,
  checkResult,
  onChangeInput,
  onCheck,
  onPrev,
  onStar,
  onSkip,
  onHome,
  disablePrev = false,
}) {
  if (!word) return null;

  return (
    <div style={{
      ...pageStyle(),
      background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)",
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1rem",
    }}>
      {/* 注入动画样式 */}
      <style>{animationStyles}</style>
      
      <div className="review-input-container" style={{
        ...mainCardStyle(),
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
        border: "1px solid rgba(255, 255, 255, 0.8)",
        position: "relative",
        width: "100%",
        maxWidth: "600px",
        maxHeight: "calc(100vh - 2rem)",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "1.5rem",
      }}>
        {/* 进度条 */}
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "#f0f0f0",
          borderRadius: "20px 20px 0 0",
          overflow: "hidden",
        }}>
          <div 
            style={{
              background: "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
              height: "100%",
              borderRadius: "2px",
              transition: "width 0.3s ease",
              width: `${(parseInt(progressText.split('/')[0]) / parseInt(progressText.split('/')[1])) * 100}%`
            }}
          />
        </div>

        <div style={{ marginTop: "4px" }}>
          <FlowTopBar
            title={`复习进度：${progressText}`}
            onPrev={onPrev}
            onStar={onStar}
            onSkip={onSkip}
            onHome={onHome}
            disablePrev={disablePrev}
          />
        </div>

        {/* 单词显示 - 增强版 */}
        <div style={{
          textAlign: "center",
          margin: "1rem 0",
          animation: "fadeInUp 0.5s ease-out 0.1s both",
        }}>
          <div style={{
            ...heroWordStyle(),
            fontSize: "2.6rem",
            fontWeight: 800,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            letterSpacing: "-0.02em",
          }}>{word.word}</div>

          <div
            onClick={() => speakFrench(word.word)}
            style={{
              ...centerSubStyle(),
              cursor: "pointer",
              marginTop: "0.4rem",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "0.4rem 0.8rem",
              borderRadius: "10px",
              background: "rgba(102, 126, 234, 0.08)",
              transition: "all 0.3s ease",
              fontSize: "1rem",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(102, 126, 234, 0.15)";
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(102, 126, 234, 0.08)";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <span style={{ fontSize: "1.2rem" }}>🔊</span>
            <span style={{ fontWeight: 500 }}>{word.phonetic}</span>
          </div>
        </div>

        <MaskedInputPlaceholder />

        {/* 输入提示 */}
        <div
          style={{
            marginTop: "1.2rem",
            textAlign: "center",
            color: "#666",
            fontWeight: 600,
            fontSize: "1rem",
            animation: "fadeInUp 0.5s ease-out 0.2s both",
          }}
        >
          <span style={{
            display: "inline-block",
            padding: "0.5rem 1rem",
            background: "linear-gradient(135deg, #fff8f0 0%, #fff 100%)",
            borderRadius: "10px",
            border: "2px solid rgba(250, 140, 22, 0.2)",
          }}>
            请输入中文意思
          </span>
        </div>

        {/* 输入框 */}
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          marginTop: "1rem",
          animation: "fadeInUp 0.5s ease-out 0.3s both",
        }}>
          <input
            value={inputValue}
            onChange={(e) => onChangeInput(e.target.value)}
            placeholder="请输入中文释义"
            className="review-input-focus"
            style={{
              width: "100%",
              maxWidth: "400px",
              border: `3px solid ${
                checkResult === "correct"
                  ? "#52c41a"
                  : checkResult === "wrong"
                  ? "#f5222d"
                  : "#d9d9d9"
              }`,
              borderRadius: "12px",
              padding: "0.8rem 1rem",
              fontSize: "1.1rem",
              textAlign: "center",
              background: "rgba(255, 255, 255, 0.9)",
              color: COLORS.text,
              outline: "none",
              transition: "all 0.3s ease",
              boxShadow: checkResult === "correct" 
                ? "0 3px 10px rgba(82, 196, 26, 0.15)"
                : checkResult === "wrong"
                ? "0 3px 10px rgba(245, 34, 45, 0.15)"
                : "0 2px 6px rgba(0, 0, 0, 0.06)",
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                onCheck();
              }
            }}
          />
        </div>

        {/* 反馈信息 */}
        {checkResult === "correct" && (
          <div
            style={{
              textAlign: "center",
              marginTop: "0.8rem",
              animation: "fadeInUp 0.3s ease-out",
            }}
          >
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "0.6rem 1.2rem",
              background: "linear-gradient(135deg, #f6ffed 0%, #fff 100%)",
              borderRadius: "10px",
              border: "2px solid rgba(82, 196, 26, 0.3)",
              color: "#52c41a",
              fontWeight: 700,
              fontSize: "0.95rem",
              boxShadow: "0 3px 10px rgba(82, 196, 26, 0.12)",
            }}>
              <span style={{ fontSize: "1.2rem" }}>✅</span>
              <span>回答正确，正在进入下一题</span>
            </div>
          </div>
        )}

        {checkResult === "wrong" && (
          <div
            style={{
              textAlign: "center",
              marginTop: "0.8rem",
              animation: "fadeInUp 0.3s ease-out",
            }}
          >
            <div style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "0.6rem 1.2rem",
              background: "linear-gradient(135deg, #fff2f0 0%, #fff 100%)",
              borderRadius: "10px",
              border: "2px solid rgba(245, 34, 45, 0.3)",
              color: "#f5222d",
              fontWeight: 700,
              fontSize: "0.95rem",
              boxShadow: "0 3px 10px rgba(245, 34, 45, 0.12)",
            }}>
              <span style={{ fontSize: "1.2rem" }}>❌</span>
              <span>回答错误，请重新输入</span>
            </div>
          </div>
        )}

        {/* 提交按钮 */}
        <button
          onClick={onCheck}
          className="review-submit-btn"
          style={{
            border: "none",
            borderRadius: "12px",
            padding: "0.9rem 1.5rem",
            color: "white",
            fontWeight: 700,
            fontSize: "1rem",
            cursor: "pointer",
            width: "100%",
            marginTop: "1.2rem",
            boxShadow: "0 4px 16px rgba(102, 126, 234, 0.25)",
            animation: "fadeInUp 0.5s ease-out 0.4s both",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            <span>提交检查</span>
            <span style={{ fontSize: "1.1rem" }}>✓</span>
          </span>
        </button>
      </div>
    </div>
  );
}